$(function () {
  (async () => {
    try {
      const response = await fetch('https://twrbhpz6v5.execute-api.us-west-2.amazonaws.com/Prod/customer/loyaltypoint', {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "email_address": customerEmail,
          "storeRegisterId": CentralCustomerId
        })
      });
      const data = await response.json();
      $('.current-reward-point').html(data.Customer.CurrentRewardPoints);

      const loyaltyRewards = data.LoyaltyRewards;

      for (let i = 0; i < loyaltyRewards.length; i++) {
        if (loyaltyRewards[i].DiscountCode != null) {
          const paidDateTime = loyaltyRewards[i].PaidDateTime.slice(0, loyaltyRewards[i].PaidDateTime.indexOf(' '));

          const ExpirationDateTime = loyaltyRewards[i].ExpirationDateTime || ' ';
          const expirationDate = ExpirationDateTime.slice(0, ExpirationDateTime.indexOf(' ')) || '-';


          const curDate = new Date()
          const formatCurDate = curDate.toISOString().split('T')[0];

          const loyaltyRewardsContainer = $('.loyalty-rewards');

          if (expirationDate > formatCurDate || expirationDate == '-') {
            loyaltyRewardsContainer.append(`
              <table>
                <tr>
                  <td class="custom-text-bold table-left">Amount</td>
                  <td>$ ${loyaltyRewards[i].PayoutAmount}</td>
                </tr>
                <tr>
                  <td class="custom-text-bold table-left">Issued On</td>
                  <td>${paidDateTime}</td>
                </tr>
                <tr>
                  <td class="custom-text-bold table-left">Expires On</td>
                  <td>${expirationDate}</td>
                </tr>
                <tr>
                  <td class="custom-text-bold table-left">Loyalty Code</td>
                  <td>${loyaltyRewards[i].DiscountCode}</td>
                </tr>
              </table>
            `);
          }
        }
      }

	  const discountCodes = data.DiscountCodes;

      for (let i = 0; i < discountCodes.length; i++) {
        if (discountCodes[i].DiscountCode != null) {
          const paidDateTime = discountCodes[i].IssuedDateTime.slice(0, discountCodes[i].IssuedDateTime.indexOf(' '));

          const ExpirationDateTime = discountCodes[i].ExpiresAtDateTime || ' ';
          const expirationDate = ExpirationDateTime.slice(0, ExpirationDateTime.indexOf(' ')) || '-';
          
          const RedeemableAfterDateTime = discountCodes[i].RedeemableAfterDateTime || ' ';
          const redeemableDate = RedeemableAfterDateTime.slice(0, RedeemableAfterDateTime.indexOf(' ')) || '-';


          const curDate = new Date()
          const formatCurDate = curDate.toISOString().split('T')[0];
          
          const discountRewardsContainer = $('.loyalty-rewards');
          if (discountCodes[i].IssuedStoreId == 28) {
            if (expirationDate > formatCurDate || expirationDate == '-') {
              discountRewardsContainer.append(`
                <table>
                  <tr>
                    <td class="custom-text-bold table-left">Amount</td>
                    <td>$ ${discountCodes[i].Value}</td>
                  </tr>
                  <tr>
                    <td class="custom-text-bold table-left">Issued On</td>
                    <td>${paidDateTime}</td>
                  </tr>
                  <tr>
                    <td class="custom-text-bold table-left">Redeemable After</td>
                    <td>${redeemableDate}</td>
                  </tr>
                  <tr>
                    <td class="custom-text-bold table-left">Expires On</td>
                    <td>${expirationDate}</td>
                  </tr>
                  <tr>
                    <td class="custom-text-bold table-left">Discount Code</td>
                    <td>${discountCodes[i].DiscountCode}</td>
                  </tr>
                  <tr>
                    <td class="custom-text-bold table-left">Discount</td>
                    <td>${discountCodes[i].DiscountShortCode}</td>
                  </tr>
                </table>
              `);
            }
          }
        }
      }

    } catch(err) {
      console.log("Error: ", err);
    }
  })();
});
